module.exports = __webpack_public_path__ + "img/D202007_5.25b8b199.jpg";